import { useEffect, useState } from 'react'
import { locationService, type LocationState } from '@/services/location'

/** Subscribes to the shared watcher. `watch: false` reads without starting it. */
export function useLocation(watch = true): LocationState {
  const [state, setState] = useState<LocationState>(locationService.current)

  useEffect(() => {
    const unsubscribe = locationService.subscribe(setState)
    const release = watch ? locationService.start() : () => {}
    return () => {
      unsubscribe()
      release()
    }
  }, [watch])

  return state
}
